import { useEffect } from 'react'

const useFacebook = (hasFacebook) => {
  useEffect(() => {
    if (hasFacebook) {
      const div = document.createElement('div')
      const script = document.createElement('script')
      div.id = 'fb-root'
      document.body.appendChild(div)
      script.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2'
      script.async = true
      script.defer = true
      document.body.appendChild(script)

      return () => document.body.removeChild(script)
    }
  }, [hasFacebook])
}

export default useFacebook
